export const USER_TYPE_MAP = {
  user: 1,
  driver: 2
};

export const USER_TYPE_ID_MAP = {
  1: 'user',
  2: 'driver'
};

export const LAYOUT_TYPE = {
  flow: 'flow',
  position: 'position'
};

export const LINK_INTERNALS = {
  1: {
    id: 1,
    name: '下单页',
    redirectType: 'businessTab',
    businessType: 1
  },
  2: {
    id: 2,
    name: '下单页大货车tab',
    redirectType: 'businessTab',
    businessType: 3
  },
  3: {
    id: 3,
    name: '下单页搬家tab',
    redirectType: 'businessTab',
    businessType: 2
  },
  4: {
    id: 4,
    name: '下单页物流tab',
    redirectType: 'businessTab',
    businessType: 5
  },
  5: {
    id: 5,
    name: '下单页企业tab',
    redirectType: 'link',
    link: 'https://eappweb.huolala.cn'
  }
};

// 折扣类型，1-立减券;2-折扣券 3-满减券
export const COUPON_DICOUNT_TYPE = {
  1: 'DISCOUNT_NO_CONDITION',
  2: 'DISCOUNT_BY_RATE',
  3: 'DISCOUNT_WITH_CONDITION'
};

// 业务券类型：1-通用券，2-搬家券，3-大货车券，4-小B货运券，5-零担物流，6-司机会员优惠券
export const COUPON_NAME = {
  1: '通用券',
  2: '搬家券',
  3: '大货车券',
  4: '货运券',
  5: '零担物流券',
  6: '司机会员优惠券'
};

export const AWARD_IMG = {
  MEMBER:
    'https://ops-img-static.huolala.cn/imgs/2021/161424176915542281713066.png',
  RED_PACKET:
    'https://ops-img-static.huolala.cn/imgs/2021/16142418958117451081185.png',
  CURRENCY:
    'https://ops-img-static.huolala.cn/imgs/2021/16142418958117451081185.png',
  COUPON: {
    // 折扣券
    DISCOUNT_BY_RATE:
      'https://ops-img-static.huolala.cn/imgs/2021/161717762441231375882772.png',
    // 立减券
    DISCOUNT_NO_CONDITION:
      'https://ops-img-static.huolala.cn/imgs/2021/161717747526226085212772.png',
    // 满减券
    DISCOUNT_WITH_CONDITION:
      'https://ops-img-static.huolala.cn/imgs/2021/161717762439616858628381.png'
  },
  REWARD_PACKAGE:
    'https://ops-img-static.huolala.cn/imgs/2021/161718965536506224289123.png',
  NULL:
    'https://ops-img-static.huolala.cn/imgs/2021/16142421391557855741230.png'
};

export const AWARD_NAME = {
  MEMBER: '权益卡',
  OIL_COUPON: '加油卡',
  RIGHT_CARD: '权益卡',
  ENTITY: '实物奖'
};

// 奖励页 tab reward type
export const TAB_REWARD_TYPE = {
  COUPON: 4,
  AWARDS: 8,
  CASH_PACK: 5
};

// PASSPORT(0)抽奖机会，COUPON(4)券，RED_PACKET(2)红包，VIRTUAL_CURRENCY(3)奖励金
// CURRENCY(5)现金，ENTITY(1)实物，MEMBER(7)会员，OIL_COUPON(6)加油卡，NULL(-1)无奖励
export const AWARD_TYPE_ID_MAP = {
  0: 'PASSPORT',
  1: 'ENTITY',
  2: 'RED_PACKET',
  3: 'VIRTUAL_CURRENCY',
  4: 'COUPON',
  5: 'CURRENCY',
  6: 'OIL_COUPON',
  7: 'MEMBER',
  '-1': 'NULL'
};

export const TASK_STATUS_TEXT = {
  // 免费领取会员
  vip: {
    incomplete: '去领取',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 参与秒杀活动
  part_ms: {
    incomplete: '去秒杀',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 完成1单
  order_complete_n: {
    incomplete: '去完成',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 收藏司机
  favorite: {
    incomplete: '去收藏',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 抢红包雨
  enter_red_packet: {
    incomplete: '去完成',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 访问福利中心页
  visit_page: {
    incomplete: '去访问',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 完成1笔充值
  recharge_n: {
    incomplete: '去充值',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 充值n元
  recharge_amount: {
    incomplete: '去充值',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 每日签到
  sign_in: {
    incomplete: '签到',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 分享
  share: {
    incomplete: '去分享',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 邀请好友
  invite_friends: {
    incomplete: '去邀请',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 打开消息通知
  open_message_push: {
    incomplete: '去打开',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 关注货主福利社
  attention_wx: {
    incomplete: '去关注',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 完善个人信息
  perfecting_personal_information: {
    incomplete: '去完成',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  }
};

export const AWARD_ERR_CODE = {
  SUCCESS: 0,
  UNDERSTOCK: 1, // 奖品无库存
  TIMEOUT: 2 // 上游服务超时
};
